import appConfig from './env';
import { SPX_SUPPORT_EMAIL } from '../consts';

/**
 * Resolved customer helpdesk/support email(s) for the current tenant.
 *
 * Takes the per-tenant `HELPDESK_EMAILS` list from env config and falls back to a
 * single-element list containing the SpecterX provider support address when a tenant
 * has not set its own, so a reported error always has at least one recipient.
 *
 * Kept in its own module to avoid a circular import: `consts/index.ts` already imports
 * from `config/env`, so resolving the default here (rather than inside `env.ts`) lets us
 * reference `SPX_SUPPORT_EMAIL` safely.
 */
export const HELPDESK_EMAILS: readonly string[] = (
    appConfig.HELPDESK_EMAILS?.length ? appConfig.HELPDESK_EMAILS : [SPX_SUPPORT_EMAIL]
);

/**
 * Comma-joined recipients suitable for a `mailto:` "to" field (RFC 6068 allows a
 * comma-separated list of mailboxes).
 */
export const HELPDESK_EMAILS_MAILTO: string = HELPDESK_EMAILS.join(',');
